import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { environment } from '../../environments/environment.prod';
import * as $ from 'jquery';
import { GoogleApiIntegrationService } from '../google-api-integration.service'
import { PwDropdownService, PwFirebaseService, PwThemeingService, PwThemeModel } from '@kaleva-media/purple-water-next';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'ata-one-life',
  templateUrl: './ata-one-life.component.html',
  styleUrls: ['./ata-one-life.component.scss']
})
export class AtaOneLifeComponent implements OnInit {

  dropdownData: any;
  agentData: any;
  isSuccess: boolean = false;
  isError: boolean = false;
  message: string = '';
  leadForm: FormGroup;
  formStatus: any = {
    formErrors: {},
    submitClicked: false
  }
  validationMessages: any;
  errorCount: number;
  error: boolean;
  showMessage: boolean;
  API_URL = environment.apiUrl;
  success: boolean = false;
  _theme: PwThemeModel;

  constructor(
    private formBuilder: FormBuilder,
    private googleApiIntegrationService: GoogleApiIntegrationService,
    private firebase: PwFirebaseService,
    private theme: PwThemeingService,
    private snackBar: MatSnackBar,
    private dropdownService: PwDropdownService) {
    
      this.dropdownData = {
      name: 'vdn',
      label: 'Product:',
      options: [{name: 'life', label: 'Life', code: '1LACW'}, {name: 'funeral', label: 'Funeral', code: '1LFAT'}],
      placeholder: 'Select Product'
    };
    
    this.agentData = {
      name: 'agentName',
      label: 'Agent Name:',
      options: [],
      placeholder: 'Select Name'
    };
  }

  ngOnInit() {
    this.createForm();

    this.googleApiIntegrationService.reatAtNames();
    this.googleApiIntegrationService.names.subscribe((names) => {
      let namesArray = JSON.parse(names);
      namesArray.map((nameArray, index) => {
        this.agentData.options[index] = {name: 'agent-' + index, label: nameArray[0]};
      });
    });

    this._theme = new PwThemeModel({
      borderColor: '#95BEE6',
      textColor: '#95BEE6',
      buttonBgColor: '#95BEE6',
      buttonTextColor: '#fff',
      errorColor: 'red',
      labelColor: 'black',
      dropdownOptionBgColor: '#95BEE6',
      dropdownOptionTextColor: '#fff'
    })
    this.theme.setTheme(this._theme);
  }

  submitLead() {
    if (this.leadForm.status !== 'VALID') {
      this.formStatus.submitClicked = true;
      this.formIsValid();
      return;
    }

    let name = this.leadForm.controls['name'].value;
    let surname = this.leadForm.controls['surname'].value;
    let telephone = this.leadForm.controls['telephone'].value;
    let vdn = this.leadForm.controls['vdn'].value;
    let agentName = this.leadForm.controls['agentName'].value;
    let campaignName = '1life';

    this.firebase.saveRecord({
      id: telephone,
      name: name,
      surname: surname,
      phone: telephone,
      vdn: vdn.code,
      campaignName: campaignName,
      agentName: agentName.label,
      date: this.getOptinDate(),
      day: this.getOptinDateObj().day,
      month: this.getOptinDateObj().month,
      year: this.getOptinDateObj().year
    }, 'leads').then(() => {
      this.firebase.updateCount('leads', campaignName).then(() => {
        this.firebase.updateCount('leads');
      });
    });

    $.post(this.API_URL, {
      name: name,
      tel: telephone,
      vdn: vdn.code,
    }, (response, status) => {
      this.error = true;
      this.showMessage = true;
      
      console.log(response);
      
      let parser = new DOMParser();
      let doc = parser.parseFromString(response, 'text/html');

      if (status === "success") {
        this.message = "Fresh Lead Submitted!"

        let apiResponseTitle = this.sanitizeString($(doc).find('title')[0].innerText);

        if (apiResponseTitle.toLowerCase() !== 'error') {
          let apiResponseSuccess = this.sanitizeString($(doc).find('font')[0].innerText);
          this.message = apiResponseSuccess;
        } else {
          let apiResponseError = this.sanitizeString($(doc).find('#lblErrorDefault')[0].innerText);
          this.message = apiResponseError;
        }

        this.googleApiIntegrationService.writeToAtLifeSheet({
          firstname: name,
          surname: surname,
          phone: telephone,
          product: vdn.label,
          agentName: agentName.label,
          status: this.message
        });

        this.snackBar.open(this.message, 'Ok!', {
          verticalPosition: "bottom", // Allowed values are  'top' | 'bottom'
          horizontalPosition: "center" // Allowed values are 'start' | 'center' | 'end' | 'left' | 'right'
        });

        this.resetForm();

      } else {
        if (status === "error") {
          this.message = "Oops, an error has occured. Please try again."
          this.isError = true;
          this.isSuccess = false;

          this.googleApiIntegrationService.writeToAtLifeSheet({
            firstname: name,
            surname: surname,
            phone: telephone,
            product: vdn.label,
            agentName: agentName.label,
            status: 'not submitted'
          });
        }
      }
    }, "html");
  }

  resetForm() {
    this.dropdownService.resetDropdown('vdn');
    this.dropdownService.resetDropdown('agentName');
    this.leadForm.reset();
  }

  createForm() {
    this.leadForm = this.formBuilder.group({
      name: ['', Validators.required],
      telephone: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(10)]],
      vdn: '',
      agentName: '',
      surname: ['', Validators.required],
    });

    this.validationMessages = {
      name: {
        'required': 'Please enter a valid name'
      },
      surname: {
        'required': 'Please enter a valid surnname'
      },
      telephone: {
        'required': 'Please enter a valid number',
        'maxlength': 'Please enter a number not greater than 10 charaters',
        'minlength': 'Please enter a number not less than 10 charaters'
      }
    }

    this.formStatus['formErrors'] = {
      name: '',
      surname: '',
      telephone: ''
    }

    this.leadForm.valueChanges.subscribe((data) => {
      this.formIsValid();
    })
  }

  formIsValid() {
    if (!this.leadForm) {
      return;
    }

    const form = this.leadForm;
    this.errorCount = 0;

    // tslint:disable-next-line:forin
    for (const field in this.formStatus['formErrors']) {
      // clear previous error message (if any)
      this.formStatus['formErrors'][field] = '';
      const control = form.get(field);

      if (control && control.dirty && !control.valid) {
        const messages = this.validationMessages[field];
        // tslint:disable-next-line:forin

        for (const key in control.errors) {

          this.formStatus['formErrors'][field] += messages[key] + ' ';

          this.errorCount++;
        }

      }
    }
  }

  sanitizeString(str){
    str = str.replace(/[^a-z0-9áéíóúñü \.,_-]/gim,"");
    return str.trim();
  }

  getOptinDate() : string {
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0');
    var yyyy = today.getFullYear();
    let strDate = dd + '/' + mm + '/' + yyyy;
    return strDate;
  }

  getOptinDateObj() : any {
    var today = new Date();
    let dateObj = {};
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0');
    var yyyy = today.getFullYear();
    let strDate = dd + '/' + mm + '/' + yyyy;
    dateObj['day'] = dd;
    dateObj['month'] = mm;
    dateObj['year'] = yyyy;
    dateObj['date'] = strDate;
    return dateObj;
  }

}
